var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-transfer',{ref:"transfer",attrs:{"titles":_vm.titles,"data":_vm.data,"render-content":_vm.rendercontent},on:{"change":_vm.handleChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }